import {
  PinChatRoomsEndpoint,
  PinChatRoomsRequest,
} from "@neard-packages/api-types/chatroom/endpoint/pin-chatrooms";
import getImClient from "utils/imClient";

export async function updatePinnedRoomIds(request: PinChatRoomsRequest) {
  return getImClient().api.main().send(new PinChatRoomsEndpoint(request));
}
